import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["state"];

  sync(event) {
    if (event.detail && event.detail.success === false) return;

    const pageSelect = document.getElementById("state");
    if (pageSelect) pageSelect.value = this.stateTarget.value;
  }
}
